import React, { useEffect, useRef, useState } from 'react'
import { GrMoreVertical } from "react-icons/gr";
import { LuSearch } from "react-icons/lu";
import Pagination from "../../components/pagination/pagination";
import { useNavigate } from 'react-router-dom';
import AssignedTeams from '../../components/modals/documets/assignedTeams';
import AssignedUsers from '../../components/modals/documets/assignedUsers';
import { Button } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

export const Translation = () => {
    const { isAdmin, isTeamLead } = useAuth();

    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filterTerm, setFilterTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationData, setPaginationData] = useState({});
    const [showOptions, setShowOptions] = useState(false);
    const [showClearIndex, setShowClearIndex] = useState(null);
    const dropdownRef = useRef(null);
    const navigate = useNavigate()



    const [selectAll, setSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [showModalUser, setShowModalUser] = useState(false);

    // Function to handle checkbox changes
    const handleCheckboxChange = (index) => {
        if (selectedItems.includes(index)) {
            setSelectedItems(selectedItems.filter(item => item !== index));
        } else {
            setSelectedItems([...selectedItems, index]);
        }
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([]);
        } else {
            setSelectedItems(data.map((_, index) => index));
        }
        setSelectAll(!selectAll);
    };

    const handleAssignUser = () => {
        setShowModalUser(true);
    };

    const handleCloseModalUser = () => {
        setShowModalUser(false);
    };

    const handleMoreOptionsClick = (item, index) => {
        if (showOptions && showClearIndex === index) {
            setShowOptions(false);
            setShowClearIndex(null);
        } else {
            setShowOptions(true);
            setShowClearIndex(index);
        }
    };


    useEffect(() => {
        setLoading(true);
        setData(teamsData);
        setFilteredData(teamsData);
        setPaginationData({ total: teamsData.length });
        setLoading(false);
    }, []);

    useEffect(() => {
        handleFilter();
    }, [filterTerm, data]);

    const handleFilter = () => {
        const filtered = data.filter(
            item =>
                item.documentName.toLowerCase().includes(filterTerm.toLowerCase()) ||
                item.sourceLanguage.toLowerCase().includes(filterTerm.toLowerCase()) ||
                item.uploadBy.toLowerCase().includes(filterTerm.toLowerCase()) ||
                item.status.toLowerCase().includes(filterTerm.toLowerCase())
        );
        setFilteredData(filtered);
        setPaginationData({ total: filtered.length });
    };

    const handleMoreOptions = (item, index) => {
        setShowClearIndex(index);
        setShowOptions(!showOptions);
    };

    return (
        <div className="d-flex vh-100">
            <div className="w-100">
                <div className="w-100 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2 justify-content-between">
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">Translation</h2>
                    <Button className='cursor_pointer fs_18 pb-1 mx-3' onClick={() => navigate('/new-translation')}>New Translation+</Button>
                </div>
                <div className="mt-4 mx-4 overflow-auto " >
                    <div className="input-group mb-3">
                        <span className="input-group-text gap-2">
                            <LuSearch />
                            Search
                        </span>
                        <input
                            type="text"
                            className="input-field w-75"
                            placeholder="Enter user name or value"
                            value={filterTerm}
                            onChange={(e) => setFilterTerm(e.target.value)}
                        />
                    </div>
                    <div className="table-responsive" style={{ minHeight: '32rem', minWidth: '100%' }}>
                        <table className="table table-bordered" >
                            <thead className="table-light">
                                <tr className="text-start text-nowrap">
                                    {isAdmin && (
                                        <th width={'3%'}>
                                            <input
                                                type="checkbox"
                                                checked={selectAll}
                                                onChange={handleSelectAll}
                                                aria-label="Select all documents"
                                            />
                                        </th>
                                    )}
                                    <th width={'4%'}>Sl No.</th>
                                    <th width={'15%'}>Document Name</th>
                                    <th width={'10%'}>Source Language</th>
                                    <th width={'10%'}>Target Language</th>
                                    <th width={'14%'}>Target Date</th>
                                    <th width={'14%'}>Translated Date</th>
                                    <th width={'14%'}>Status</th>
                                    <th width={'35%'}>Comments</th>

                                    {(isAdmin || (isTeamLead && !isAdmin)) && <th width={'2%'}></th>}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="7">
                                        </td>
                                    </tr>
                                ) : filteredData?.length > 0 ? (
                                    filteredData?.map((item, index) => (
                                        <tr key={index} className='text-start'>
                                            {isAdmin && (
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedItems.includes(index)}
                                                        onChange={() => handleCheckboxChange(index)}
                                                        aria-label={`Select document ${item.documentName}`}
                                                    />
                                                </td>
                                            )}
                                            <td>{index + 1}</td>
                                            <td>{item.documentName}</td>
                                            <td>{item.sourceLanguage}</td>
                                            <td>{item.targetLanguage}</td>
                                            <td>{item.target_date}</td>
                                            <td>{item.translated_date}</td>
                                            <td>{item.status}</td>
                                            <td >{item.comments}</td>

                                            {isAdmin || (isTeamLead && !isAdmin) ? (
                                                <td>
                                                    <GrMoreVertical
                                                        className="cursor_pointer"
                                                        onClick={() => handleMoreOptions(item, index)}
                                                    />
                                                    {showOptions && showClearIndex === index && (
                                                        <div className="position-relative" ref={dropdownRef}>
                                                            <div className="position-absolute" style={{ left: "-10rem" }}>
                                                                <div className="card" style={{ width: '10rem' }}>
                                                                    <div className="card-body p-2">
                                                                        {isAdmin && (
                                                                            <>
                                                                                <label className="d-block mb-2 cursor_pointer text-nowrap" onClick={() => navigate('/upload-documents')} ></label>
                                                                                <label className="d-block text-danger cursor_pointer">Delete</label>
                                                                            </>
                                                                        )}
                                                                        {(isTeamLead || isAdmin) && (
                                                                            <label className="d-block mb-2 cursor_pointer text-nowrap " onClick={() => navigate('/assign-user')}>Send for Post-editing</label>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </td>
                                            ) : null}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7">No rows to display</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {paginationData?.total > 10 && (
                        <div className="d-flex mt-3 justify-content-end mx-3">
                            <Pagination
                                data={paginationData}
                                nextFunc={() => setPage(page + 1)}
                                prevFunc={() => setPage(page - 1)}
                                setPageRowFunc={(value) => {
                                    setPage(1);
                                    setRowsPerPage(value);
                                }}
                            />
                        </div>
                    )}
                </div>
                <AssignedUsers title='Post-editing' show={showModalUser} handleClose={handleCloseModalUser} showAddRemoveButtons={false} />
            </div >
        </div >
    )
}


export const teamsData = [
    {
        "slNo": 1,
        "documentName": "Form 1040-X - Feb 2024",
        "sourceLanguage": "English",
        "status": "Translated",
        "comments": " Initial document Uploaded for translation by Admin.",
        "target_date": "12/31/2024,9:00 AM",
        "targetLanguage": "German",
        "translated_date": "12/28/2024,10:00 AM"
    },
    {
        "slNo": 2,
        "documentName": "Budget Report.xlsx",
        "sourceLanguage": "French",
        "status": "Translated",
        "comments": "Uploaded Document is assigned to team lead for translation by Admin.",
        "target_date": "12/31/2024,1:00 PM",
        "targetLanguage": "German",
        "translated_date": "12/28/2024 10:00 AM"
    },
    {
        "slNo": 3,
        "documentName": "Meeting Notes.docx",
        "sourceLanguage": "Spanish",
        "status": "Sent for Post-editing ",
        "comments": "The document is currently being translated bt Team lead ",
        "target_date": "12/31/2024 11:00 AM",
        "targetLanguage": "German",
        "translated_date": "12/28/2024 1:00 PM"
    },
    {
        "slNo": 4,
        "documentName": "Product Specification.pdf",
        "sourceLanguage": "German",
        "status": "In HIL Editing",
        "comments": "The document is currently being Edited.",
        "target_date": "12/31/2024 1:00 PM",
        "targetLanguage": "German",
        "translated_date": "12/26/2024 2:00 PM"
    },
    {
        "slNo": 5,
        "documentName": "User Manual.docx",
        "sourceLanguage": "Chinese",
        "status": "Published",
        "comments": "The translated document has been finalized and published or delivered",
        "target_date": "12/31/2024 2:00 PM",
        "targetLanguage": "German",
        "translated_date": "12/26/2024 3:00PM"


    }
]